import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .controller('AssignedToFilterController', AssignedToFilterController);

    function AssignedToFilterController(CompaniesFactory, LocalStorageService) {
        var vm = this;

        init();

        function init() {
            CompaniesFactory.readEmployees(
                LocalStorageService.getObject('common/company').organization
                    .party_uuid,
                { page_size: 100 }
            ).then(function (response) {
                vm.users = response.data.results;
            });
        }
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/issues/filters/assigned-to-filter/assigned-to-filter.controller.ts